// SSO SOP step 1E loader: on first scroll/mousemove/touch or 6s after load, loads opt_lazy images,
// data-href CSS and noscript-s scripts in order, then fires `wnw_load`.
(function () {
  let windowWidth;
  let loaded = false;
  const lazyLoadByPx = 200;

  function init() {
    if (loaded) return;

    loaded = true;
    lazyLoadImg();
    lazyLoadBackground();
    lazyLoadCss();
    lazyLoadScripts();
  }

  /**
   * @param {Element} newNode
   * @param {Element} referenceNode
   */
  function insertAfter(newNode, referenceNode) {
    try {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    } catch (error) {
      console.error(error);
    }
  }

  function lazyLoadImg() {
    const windowHeight = window.innerHeight;

    for (const image of document.querySelectorAll('img.opt_lazy')) {
      const rect = image.getBoundingClientRect();
      if (rect.top === 0 || rect.top - windowHeight >= lazyLoadByPx) continue;

      const src = windowWidth < 600 && image.dataset.mobsrc !== undefined ? image.dataset.mobsrc : image.getAttribute('data-src');
      const srcset = image.getAttribute('data-srcset');
      if (src) image.src = src;
      if (srcset) image.srcset = srcset;
      image.classList.remove('opt_lazy');
    }
  }

  function lazyLoadBackground() {
    for (const element of document.querySelectorAll('.opt_bg_lazy')) {
      const lazybg = windowWidth < 600 && element.dataset.mobstyle !== undefined ? element.dataset.mobstyle : element.dataset.bg;
      if (lazybg) element.style.backgroundImage = lazybg;
      element.classList.remove('opt_bg_lazy');
    }
  }

  function lazyLoadCss() {
    for (const link of document.querySelectorAll('link[data-href]')) {
      const newLink = document.createElement('link');
      newLink.href = link.getAttribute('data-href');
      newLink.rel = 'stylesheet';
      link.parentNode.insertBefore(newLink, link);
      link.parentNode.removeChild(link);
    }
  }

  /**
   * @param {HTMLScriptElement} scriptElement
   * @returns {HTMLScriptElement}
   */
  function loadRemoteScript(scriptElement) {
    const newScript = document.createElement('script');
    for (const attribute of scriptElement.attributes) {
      if (attribute.name !== 'type' && attribute.name !== 'data-src') {
        newScript.setAttribute(attribute.name, attribute.value);
      }
    }
    newScript.src = scriptElement.getAttribute('data-src');
    insertAfter(newScript, scriptElement);
    scriptElement.parentNode.removeChild(scriptElement);
    return newScript;
  }

  /** @param {HTMLScriptElement} scriptElement */
  function loadInlineScript(scriptElement) {
    const newScript = document.createElement('script');
    for (const attribute of scriptElement.attributes) {
      if (attribute.name !== 'type') newScript.setAttribute(attribute.name, attribute.value);
    }
    newScript.innerHTML = scriptElement.innerHTML;
    insertAfter(newScript, scriptElement);
    scriptElement.parentNode.removeChild(scriptElement);
  }

  // One script at a time, in document order, so dependencies keep their order
  function lazyLoadScripts() {
    const script = document.querySelector('script[type=noscript-s]');
    if (!script) {
      setTimeout(() => window.dispatchEvent(new Event('wnw_load')), 200);
      return;
    }

    if (script.getAttribute('data-src') !== null) {
      const loadedScript = loadRemoteScript(script);
      loadedScript.onload = lazyLoadScripts;
      loadedScript.onerror = lazyLoadScripts;
    } else {
      loadInlineScript(script);
      lazyLoadScripts();
    }
  }

  if (window.isBot) return;

  const onFirstInteraction = () => {
    lazyLoadImg();
    init();
  };

  // Deferred script: the DOM is already parsed here, so no DOMContentLoaded wrapper is needed
  windowWidth = screen.width;
  window.addEventListener('scroll', onFirstInteraction);
  window.addEventListener('mousemove', onFirstInteraction);
  window.addEventListener('touchstart', onFirstInteraction);

  window.addEventListener('load', () => {
    setTimeout(init, 6000);
  });
})();
